import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
const initialState = {
  isProfileDeletion:false,
  patient: null,
  currentVitals:null,
  currentEcg:null,
  selectedVitals:null,
  selectedEcg:null,
  selectedAppointment: null,
  selectedSpecialties: [],
  selectedHospitals:[],
}
export const useStore = create(
  persist(
    (set, get) => ({
     ...initialState,
      setPatient: (patient) => set({ patient }),
      setCurrentVitals: (vital) => set({ currentVitals:vital }),
      setCurrentEcg: (ecg) => set({ currentEcg:ecg }),
      setSelectedVitals:(vital) => set({ selectedVitals:vital }),
      setSelectedEcg:(ecg) => set({ selectedEcg:ecg }),
      setAppointment: (appointment) =>
        set({ selectedAppointment: appointment }),
      setSelectedSpecialties: (specialties) =>
        set({ selectedSpecialties: specialties }),
      reset: () => set(initialState),
      setProfileDeletion: (isDeletion) => set({ isProfileDeletion:isDeletion }),
      setHospitals: (hospitals) => set({ selectedHospitals:hospitals }),
    }),
    {
      name: "prognosis-store",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
